module.exports = __webpack_public_path__ + "img/DCIBg02.3acc4ffa.png";